import React from 'react';
import { useGlobalModals } from '@/contexts/GlobalModalsContext';
import CategoryManagementModal from '@/components/universal-storage/CategoryManagementModal';
import CreditWarningModal from './CreditWarningModal';
import InviteMembersModal from './InviteMembersModal';

/**
 * GlobalModalsContainer
 * 
 * This component renders all global modals at the top level of the app,
 * completely isolated from other components to prevent event conflicts.
 * 
 * All modals are controlled through the GlobalModalsContext.
 * 
 * OPTIMIZED: Only renders modal components when they are actually open
 * to prevent unnecessary mounting and execution on pages like sign-in.
 */
const GlobalModalsContainer: React.FC = () => {
  const { 
    isCategoryModalOpen, 
    closeCategoryModal,
    isOutOfCreditsModalOpen,
    closeOutOfCreditsModal,
    isInviteMembersModalOpen,
    inviteMembersWorkbookId,
    closeInviteMembersModal,
  } = useGlobalModals();

  return (
    <>
      {/* Category Management Modal - Only render when open */}
      {isCategoryModalOpen && (
        <CategoryManagementModal 
          isOpen={isCategoryModalOpen} 
          onClose={closeCategoryModal} 
        />
      )}

      {/* Out of Credits Modal - Only render when open */}
      {isOutOfCreditsModalOpen && (
        <CreditWarningModal
          isOpen={isOutOfCreditsModalOpen}
          onClose={closeOutOfCreditsModal}
          warningType="out"
        />
      )}

      {/* Invite Members Modal - Only render when open */}
      {isInviteMembersModalOpen && (
        <InviteMembersModal
          isOpen={isInviteMembersModalOpen}
          onClose={closeInviteMembersModal}
          workbookId={inviteMembersWorkbookId || undefined}
        />
      )}

      {/* Future modals can be added here with the same conditional pattern */}
    </>
  );
};

export default GlobalModalsContainer; 